/* @jsx jsx */

import type { PropsWithChildren } from 'react';
import { css, jsx } from '@compiled/react';
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import { token } from '@atlaskit/tokens';
import FilterSearch from '@atlassian/jira-common-analytics-v2-wrapped-components/src/filter-search';
import { ff } from '@atlassian/jira-feature-flagging';
import { componentWithFF } from '@atlassian/jira-feature-flagging-utils';
import ProjectTypePicker from '@atlassian/jira-project-type-picker';
import type { Props } from './types';
import { getProjectTypes } from './utils';

const Filters = (props: Props) => {
	const { onFilterChange, filters, ariaLabelText } = props;
	const onProjectTypePickerChange = (value: ReadonlyArray<string>): void => {
		onFilterChange({ typeKey: value });
	};

	const onFilterSearchChange = (value: string): void => {
		onFilterChange({ query: value });
	};

	return (
		<FilterContainer>
			{ff('hix-4799-convert-styled-components-to-compiled-and-primitives_bm4r3') ? (
				<FilterSearch
					value={filters.query}
					onChange={onFilterSearchChange}
					isAlwaysExpanded
					ariaLabelText={ariaLabelText}
					placeholder=""
					hasAutoFocus={false}
					isCompact
					increasedWidth={false}
					placeholderAlwaysVisible={false}
				/>
			) : (
				/* @ts-expect-error - Type '{ value: string; onChange: (value: string) => void; isAlwaysExpanded: true; ariaLabelText: string | undefined; }' is missing the following properties from type 'Omit<{ value: string; placeholder: string; describedById?: string | undefined; hasAutoFocus: boolean; isCompact: boolean; onChange: (value: string, args_1: UIAnalyticsEvent) => void; ... 6 more ...; key?: Key | ... 1 more ... | undefined; }, keyof WithAnalyticsEventsProps>': placeholder, hasAutoFocus, isCompact, increasedWidth, placeholderAlwaysVisible */
				<FilterSearch
					value={filters.query}
					onChange={onFilterSearchChange}
					isAlwaysExpanded
					ariaLabelText={ariaLabelText}
				/>
			)}
			<ProjectTypePicker
				ariaLabelText={ariaLabelText}
				defaultSelected={filters.typeKey}
				projectTypes={getProjectTypes()}
				onChange={onProjectTypePickerChange}
			/>
		</FilterContainer>
	);
};

export default Filters;

const FilterContainerStyles = css({
	position: 'relative',
	display: 'flex',
	gap: token('space.200'),
	marginBottom: token('space.200', '16px'),
});

const FilterContainerNew = ({ children }: PropsWithChildren<{}>) => (
	<div css={FilterContainerStyles}>{children}</div>
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const FilterContainerOld = styled.div<any>({
	position: 'relative',
	display: 'flex',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'& > :not(:last-child)': {
		marginRight: token('space.200', '16px'),
	},
	marginBottom: token('space.200', '16px'),
});

const FilterContainer = componentWithFF(
	'hix-4799-convert-styled-components-to-compiled-and-primitives_bm4r3',
	FilterContainerNew,
	FilterContainerOld,
);
